import React from 'react'

export default function Header() {
  return (
    <div className='font-mono text-lg text-white w-[35%] flex max-[992px]:text-base max-[742px]:text-sm max-[634px]:text-xs max-[455px]:text-[10px]'>
    <span className='text-[#62B46E]'>The</span>Programmer
    </div>
  )
}
